import EmailLogFilterContainer from './email-log-filter.container';

export default EmailLogFilterContainer;
